// extracted by mini-css-extract-plugin
export default {"button":"VBXDO","disabled":"_8iR5y","mobile-button":"_6+4Od","mobileButton":"_6+4Od"};